module.exports = __webpack_public_path__ + "img/20.29e5acf1.jpg";